import { createFileRoute, redirect } from "@tanstack/react-router";

// The prototype's store wizard was retired in M2c; opening a store is /sell now (docs/plans/marketplace-commerce.md
// M3). /sell sends signed-out visitors to /join and brings them back.
export const Route = createFileRoute("/_onboarding/onboarding/store")({
  beforeLoad: () => {
    throw redirect({ href: "/sell", replace: true });
  },
});
